<script lang="ts">
  import { Info, CaretDown, CaretRight } from 'phosphor-svelte';
  import { popup, SlideToggle } from '@skeletonlabs/skeleton';
  import type { GetAliiNotificationCategoryResponse } from '$lib/models/alii-notification-category/types';
  import type { PutBridgeClientNotificationRequest } from '$lib/models/client/types';
  import Tooltip from '$lib/components/common/tooltip/Tooltip.svelte';
  import { GetHoverPopupSettings } from '$lib/components/common/tooltip/utils';

  export let notificationType: GetAliiNotificationCategoryResponse;
  export let notificationConfig: PutBridgeClientNotificationRequest;
  export let hasChildren: boolean = false;
  export let isExpanded: boolean = false;
  export let isChild: boolean = false;
  export let toggleExpandAction: (() => void) | undefined = undefined;

  const popupId: string = `popup_notification_${notificationType.id}`;
  const tooltipSettings = GetHoverPopupSettings(popupId);
</script>

<div class="col-span-5 inline-flex items-center gap-2 {isChild ? 'pl-12' : ''}">
  {#if hasChildren}
    <button
      type="button"
      class="inline-flex h-5 w-5 items-center justify-center rounded text-surface-900 hover:bg-surface-200 hover:text-primary-700 transition-colors"
      aria-label={isExpanded ? 'Collapse notification group' : 'Expand notification group'}
      on:click|preventDefault|stopPropagation={() => toggleExpandAction?.()}
    >
      {#if isExpanded}
        <CaretDown size={16} />
      {:else}
        <CaretRight size={16} />
      {/if}
    </button>
  {:else if !isChild}
    <span class="inline-block w-5"></span>
  {/if}
  <span>{notificationType.name}</span>
  <button class="[&>*]:pointer-events-none" use:popup={tooltipSettings}>
    <Info />
  </button>
</div>
<div class="col-span-2 flex items-center gap-2">
  <input type="checkbox" bind:checked={notificationConfig.applyToAllUsers} />
  {#if notificationConfig.applyToAllUsers}
    <span
      class="rounded px-2 py-1 text-xs {notificationConfig.inApp || notificationConfig.email
        ? 'bg-success-100 text-success-700 border-success-300 border'
        : 'bg-error-100 text-error-700 border-error-300 border'}"
    >
      {notificationConfig.inApp || notificationConfig.email ? 'Add to all users' : 'Remove from all users'}
    </span>
  {/if}
</div>
<div>
  <SlideToggle name={`${notificationType.id}_app`} bind:checked={notificationConfig.inApp} active="bg-success-500" background="bg-secondary-600" />
</div>
<div>
  <SlideToggle name={`${notificationType.id}_email`} bind:checked={notificationConfig.email} active="bg-success-500" background="bg-secondary-600" />
</div>

<Tooltip config={tooltipSettings}>
  {notificationType.description}
</Tooltip>
